"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStableSwapOutputAmount = exports.calculateSwapToBase = exports.calculateSwapFromBase = void 0;
const currency_1 = require("@zenlink-interface/currency");
const math_1 = require("@zenlink-interface/math");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
function calculateSwapFromBase(pool, basePool, tokenIndexFrom, tokenIndexTo, amount) {
    const baseToken = basePool.liquidityToken;
    const baseTokenIndex = pool.getTokenIndex(baseToken);
    const baseAmounts = basePool.pooledTokens.map(token => currency_1.Amount.fromRawAmount(token, math_1.ZERO));
    baseAmounts[tokenIndexFrom] = amount;
    const baseLpAmount = basePool.calculateTokenAmount(baseAmounts, true);
    if (baseTokenIndex === tokenIndexTo)
        return baseLpAmount;
    return pool.calculateSwap(baseTokenIndex, tokenIndexTo, baseLpAmount);
}
exports.calculateSwapFromBase = calculateSwapFromBase;
function calculateSwapToBase(pool, basePool, tokenIndexFrom, tokenIndexTo, amount) {
    const baseToken = basePool.liquidityToken;
    const baseTokenIndex = pool.getTokenIndex(baseToken);
    let tokenLPAmount = amount;
    if (baseTokenIndex !== tokenIndexFrom)
        tokenLPAmount = pool.calculateSwap(tokenIndexFrom, baseTokenIndex, amount);
    return basePool.calculateRemoveLiquidityOneToken(tokenLPAmount, tokenIndexTo)[0];
}
exports.calculateSwapToBase = calculateSwapToBase;
function getStableSwapOutputAmount(path, inputAmount) {
    let outputAmount;
    (0, tiny_invariant_1.default)(path.stable, 'NOT_STABLESWAP');
    (0, tiny_invariant_1.default)(inputAmount.currency.equals(path.input), 'INPUTTOKEN');
    try {
        if (!path.basePool && path.pool) {
            const fromIndex = path.pool.getTokenIndex(path.input);
            const toIndex = path.pool.getTokenIndex(path.output);
            outputAmount = path.pool.calculateSwap(fromIndex, toIndex, inputAmount);
        }
        else if (path.fromBase) {
            (0, tiny_invariant_1.default)(path.pool && path.basePool, 'POOL');
            const fromIndex = path.basePool.getTokenIndex(path.input);
            const toIndex = path.pool.getTokenIndex(path.output);
            outputAmount = calculateSwapFromBase(path.pool, path.basePool, fromIndex, toIndex, inputAmount);
        }
        else {
            (0, tiny_invariant_1.default)(path.pool && path.basePool, 'POOL');
            const fromIndex = path.pool.getTokenIndex(path.input);
            const toIndex = path.basePool.getTokenIndex(path.output);
            outputAmount = calculateSwapToBase(path.pool, path.basePool, fromIndex, toIndex, inputAmount);
        }
        return outputAmount;
    }
    catch {
        return currency_1.Amount.fromRawAmount(path.output, math_1.ZERO);
    }
}
exports.getStableSwapOutputAmount = getStableSwapOutputAmount;
